import { toggleClass } from "./toggleClass";

export function toggleBlanket(elementIdToActivate) {
  toggleClass(elementIdToActivate, 'blanket-active');
  toggleClass('blanket', 'd-none');
}

export function toggleModalBlanket(elementIdToActivate) {
  toggleClass(elementIdToActivate, 'blanket-active');
  toggleClass('modal-blanket', 'd-none');
}
